import gql from 'graphql-tag';

export const mutationSendDokkioUserPasswordReset = gql`
  mutation sendDokkioUserPasswordReset (
    $accountID: DokkioID!
    $primaryEmail: String!
  ) {
    sendDokkioUserPasswordReset (
      accountID: $accountID
      primaryEmail: $primaryEmail
    )
  }
`;
export default mutationSendDokkioUserPasswordReset;
